<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Register</p>
      <b-button type="button" icon-left="close" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <form @keydown.enter="register()">
        <b-field label="E-mail" label-position="inside">
          <b-input v-model="email"></b-input>
        </b-field>
        <b-field label="Username" label-position="inside">
          <b-input v-model="username"></b-input>
        </b-field>
        <b-field label="Password" label-position="inside">
          <b-input type="password" v-model="password"></b-input>
        </b-field>
        <div class="block">
          <small>I agree to the terms of service</small>
        </div>
        <b-button @click="register()" type="is-success" class="mb-1" expanded>Create account</b-button>
        <b-button @click="openLogin()" expanded type="is-text">I already have an account</b-button>
      </form>
    </section>
    <footer class="modal-card-foot">
    </footer>
  </div>
</template>
<script>
import ApiService from '../common/api.service'
import { USER_INIT, USER_REGISTER } from '../store/User/action.type'
import Login from "./Login.vue"

export default {
  data() {
    return {
      activeTab: 0,
      email: null,
      username: null,
      password: null
    }
  },
  methods: {
    async register() {
      const response = await this.$store.dispatch(USER_REGISTER, { email: this.email, username: this.username, password: this.password })
      if (response.status == 200 || response.status == 201) {
        await this.$store.dispatch(USER_INIT)
        gtag("event", "conversion", {
          send_to: "AW-974458431/MAUNCPLdnpMDEL-c1NAD",
        })

        this.$emit('close')
      }
    },
    openLogin() {
      this.$emit('close')
      this.$buefy.modal.open({
        parent: this,
        component: Login,
        hasModalCard: true,
        trapFocus: true
      })
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
